import React, { useState } from 'react';
import { Box, Button, MenuItem, Select, TextField } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
type Props = {
  onFilter: (startDate?: string, endDate?: string, month?: string) => void;
};
const DateOrMonthFilter: React.FC<Props> = ({ onFilter }) => {
  const [filterType, setFilterType] = useState<'none' | 'range' | 'month'>('none');
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [selectedMonth, setSelectedMonth] = useState<string | null>(null);
  const handleApply = () => {
    if (filterType === 'range' && startDate && endDate) {
  onFilter(startDate, endDate);
} else if (filterType === 'month' && selectedMonth) {
  const start = `${selectedMonth}-01`;
  const end = dayjs(start).endOf('month').format('YYYY-MM-DD');
  onFilter(start, end, selectedMonth);
} else {
  // שלח טווח רחב כברירת מחדל
  onFilter("2000-01-01", "2099-12-31", undefined);
}

  };
  return (
    <Box display="flex" alignItems="center" gap={2} mb={4}>
      <Select value={filterType} onChange={(e) => setFilterType(e.target.value as any)}>
        <MenuItem value="none">הצג הכל</MenuItem>
        <MenuItem value="range">טווח תאריכים</MenuItem>
        <MenuItem value="month">חודש</MenuItem>
      </Select>
      {filterType === 'range' && (
        <>
          <TextField
            label="תאריך התחלה"
            type="date"
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setStartDate(e.target.value)}
            fullWidth
          />
          <TextField
            label="עד תאריך"
            type="date"
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setEndDate(e.target.value)}
            fullWidth
          />
        </>
      )}
      {filterType === 'month' && (
        <TextField
          label="בחר חודש (YYYY-MM)"
          type="month"
          InputLabelProps={{ shrink: true }}
          onChange={(e) => setSelectedMonth(e.target.value)}
          fullWidth
        />
      )}
      <Button variant="contained" onClick={handleApply}>
        סנן
      </Button>
    </Box>
  );
};
export default DateOrMonthFilter;